import React from 'react';
import _ from 'lodash';
import SaleCallChartSettings from './SaleCallChartSettings';

function NumberWidgetBarSettings(props) {
    return (
        props.widget.widgetType !== 'saleCall' ? <div>
            <div className="displaySettings-row">
                <span className="title">Budget</span>
                <input
                    className="form-control"
                    type="text"
                    placeholder="Hämta från Upsales"
                    value={_.get(props.widget, 'displayConfig.budget') || ''}
                    onChange={(event) => {
                        props.setWidgetFieldValue(
                            'displayConfig.budget',
                            parseInt(event.target.value, 10) || '',
                        );
                    }}
                />
            </div>
        </div> : <SaleCallChartSettings {...props} />
    );
}

NumberWidgetBarSettings.propTypes = {
    setWidgetFieldValue: React.PropTypes.func,
    widget: React.PropTypes.object,
};

export default NumberWidgetBarSettings;



/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/DisplaySettings/NumberWidgetBarSettings.jsx
 **/